import { HttpService } from 'services/HttpService';
import { API_URL, tenantConfig } from 'config';
import AuthService from 'services/AuthService';
import { httpRequestWrapper } from 'util/Request';
import TenantConfig from 'store/types/TenantConfig';

class AdminService {
  public static resetCache(): Promise<null> {
    return new Promise<null>((resolve: (data: null) => void, reject: (error: string) => void) => {
      httpRequestWrapper<null>(
        HttpService.delete(`${API_URL}/caching`, {
          headers: {
            TenantId: tenantConfig.id,
            authorization: AuthService.getBearerToken(),
          },
        }),
        resolve,
        reject
      );
    });
  }

  public static getTenantConfig(): Promise<TenantConfig> {
    return new Promise<TenantConfig>((resolve: (data: TenantConfig) => void, reject: (error: string) => void) => {
      httpRequestWrapper<TenantConfig>(
        HttpService.get(`${API_URL}/admin/tenants/${tenantConfig.id}`, {
          headers: {
            TenantId: tenantConfig.id,
            authorization: AuthService.getBearerToken(),
          },
        }),
        resolve,
        reject
      );
    });
  }
}

export default AdminService;
